import React, { FC, Key, useEffect, useState } from 'react'
import './LineManagerTeam.scss'
import { Link } from 'react-router-dom'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { EmployeeType } from 'Models'
import employeeService from 'Services/employeeService'
import { TableSerialNumber } from 'Helpers'
import { HorizontalLoader, ImageSrc, Pagination } from 'Components'
import profileService from 'Services/profileService'

const LineManagerTeam: FC<{ showTeam?: (val: boolean) => void }> = ({ showTeam }) => {
  const { showAlert } = ShowTGAlert()

  const [pageNumber, setPage] = useState(1)
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [sortOrder, setSortOrder] = useState('DESC')

  const [profile, setProfile] = useState<EmployeeType>()

  const getProfile = async () => {
    await profileService.profile().then((response) => {
      // console.log('profileService', response.data.data)
      setProfile(response.data.data)
    })
  }

  useEffect(() => {
    getProfile()
  }, [])
  const getUsers = async () => {
    setLoading(true)
    await employeeService.lineManagerIndex(pageNumber, profile?.id).then(
      // await employeeService.index(pageNumber, sortOrder).then(
      (response) => {
        // console.log('employeeService', response?.data)

        setLoading(false)

        const dataSet = response?.data.data.dataset
        setCustomers(dataSet)

        showTeam && showTeam(dataSet.length > 0)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })

        setLoading(false)
      },
    )
  }

  useEffect(() => {
    if (profile) getUsers()
  }, [pageNumber, sortOrder, profile])

  return (
    <div className='LineManagerTeam'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-6 col-md-6 my-auto'>
                  <div className='title'>{paginationData.total} team members</div>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Fullname</td>
                      <td>Photo</td>
                      <td>Email</td>
                      <td>Phone Number</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.length > 0 &&
                      customers.map((data: EmployeeType, index: Key) => (
                        <tr key={index}>
                          <td className='accountIdCol'>
                            {TableSerialNumber(
                              pageNumber,
                              paginationData.pageSize,
                              parseInt(index.toString()),
                            )}
                          </td>
                          <td>
                            {data.firstName} {data.lastName}
                          </td>
                          <td>
                            <ImageSrc
                              src={data.photo?.url}
                              alt={''}
                              title={''}
                              width={'profile-image'}
                            ></ImageSrc>
                          </td>
                          <td>{data.emailAddress}</td>
                          <td>{data.msisdn}</td>

                          <td className='dropdown option-dropdown'>
                            <button
                              className='btn border-0 dropdown-toggle'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              <svg
                                width='18'
                                height='18'
                                viewBox='0 0 18 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                  fill='#707070'
                                />
                              </svg>
                            </button>

                            <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                              <li className='dropdown-item'>
                                <Link to={`/team-appraisal/${data.id}`} className='w-100 d-block'>
                                  Appraisal Log
                                </Link>
                              </li>
                              <li className='dropdown-item'>
                                <Link to={`/kpi-manager/${data.id}`} className='w-100 d-block'>
                                  Manage KPI
                                </Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    {loading === false && customers.length === 0 && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          No team member found
                        </td>
                      </tr>
                    )}
                    {loading === true && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationData.total >= paginationData.pageSize && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  {paginationData.total && (
                    <Pagination
                      className='pagination-bar ps-0'
                      currentPage={Number(paginationData.pageNumber)}
                      totalCount={paginationData.total}
                      pageSize={paginationData.pageSize}
                      onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LineManagerTeam
